/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dark_Swift_Owl_HuntInputs */

const en_dark_swift_owl_hunt = /** @type {(inputs: Dark_Swift_Owl_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore this version`)
};

const de_dark_swift_owl_hunt = /** @type {(inputs: Dark_Swift_Owl_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Version wiederherstellen`)
};

/**
* | output |
* | --- |
* | "Restore this version" |
*
* @param {Dark_Swift_Owl_HuntInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dark_swift_owl_hunt = /** @type {((inputs?: Dark_Swift_Owl_HuntInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dark_Swift_Owl_HuntInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dark_swift_owl_hunt(inputs)
	return de_dark_swift_owl_hunt(inputs)
});